import { render, staticRenderFns } from "./new-candidate.vue?vue&type=template&id=60aa226d&"
import script from "./new-candidate.vue?vue&type=script&lang=js&"
export * from "./new-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports